import styled, { css } from 'styled-components';
import { Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

import { space } from 'styled-system';
import colors from 'UIKit/Colors';

import { Box } from 'UIKit/Grid';

import InfoIcon from '@/assets/img/InfoIcon.png';

export const ModalTitle = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 400px;
  margin-bottom: 24px;
`;

export const FormGroup = styled.div`
  position: relative;
  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const SagnificantText = styled.span`
  font-weight: bold;
`;

/*
styled(Select)`
  width: 50%;
  overflow: hidden;
  .MuiSelect-root {
    background: #e19635 !important;
    border-radius: 5px 0 0 5px !important;
    color: #fff;
    font-size: 12px;
    text-align: center;
    font-family: Montserrat, sans-serif;
    padding-left: 10px;
  }
  .MuiSvgIcon-root {
    display: none;
  }
  &:before {
    display: none;
  }
  &:after {
    display: none;
  }
  .MuiPopover-root {
    background: red;
  }
`;
*/

export const SimpleButton = styled.button`
  border: 0;
  background: none;
  box-shadow: none;
  text-shadow: none;
  text-align: left;
  padding: 0;
  &:hover {
    box-shadow: none;
    text-shadow: none;
  }
  &:disabled {
    color: #aaa;
    cursor: not-allowed;
    text-decoration: none;
  }
`;

export const InputIcon = styled.div`
  position: absolute;
  top: 9px;
  right: 24px;
  svg {
    fill: ${colors.gray['900']};
  }
`;

export const InputDateGroup = styled.div`
  display: flex;
  border: 1px solid #ddd;
  border-radius: 2px;
  input {
    height: 28px;
    border: 0;
  }
`;

export const InputDateIcon = styled.div`
  opacity: 0.4;
  display: flex;
  align-items: center;
  padding: 0 16px;
  color: ${colors.brand['500']};
`;

export const InputStyled = styled(Field)`
  position: relative;
  width: 100% !important;
  max-width: 100%;
  height: 28px;
  padding: 0.625rem;
  padding-right: 35px;
  border: 1px solid #ddd;
  border-radius: 20px;
  color: #464d69;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  overflow: hidden;
  text-overflow: ellipsis;
  &:focus {
    border-color: ${colors.brand['500']};
    outline: 0;
  }
  ${({ icon }) =>
    icon &&
    css`
      padding-left: 48px;
    `};
`;

export const NumStyled = styled(InputStyled)`
  width: 96px !important;
  padding-right: 16px;
  ${({ long }) =>
    long &&
    css`
      width: 100% !important;
      max-width: 160px !important;
    `};
`;

export const TextareaStyled = styled(InputStyled)`
  min-height: 112px;
`;

export const IconForInput = styled(Box)`
  position: absolute;
  z-index: 1;
  bottom: 9px;
  left: 16px;
`;

export const Toggle = styled.label`
  input {
    position: absolute;
    left: -9999px;
    &:focus,
    &:active {
      outline: 0;
    }
    &:checked {
      ~ span {
        background-image: linear-gradient(-225deg, #1de9b6 0%, #1dc4e9 100%);
        &:after {
          transform: translateX(0);
        }
      }
    }
  }
  span {
    position: relative;
    cursor: pointer;
    display: block;
    width: 38px;
    height: 20px;
    border-radius: 83px;
    background: #e3e3e3;
    &:after {
      content: '';
      position: absolute;
      display: block;
      top: 2px;
      left: 50%;
      width: 16px;
      height: 16px;
      border-radius: 100%;
      background-color: #fff;
      transform: translateX(-100%);
      transition: transform 0.3s ease-in-out;
    }
  }
`;

export const RadioBtn = styled.label`
  user-select: none;
  input {
    position: absolute;
    left: -9999px;
    &:focus,
    &:active {
      outline: 0;
    }
    &:checked {
      ~ div {
        &:before {
          opacity: 1;
        }
        &:after {
          border-color: transparent;
          transform: scale(0.4);
        }
      }
    }
  }
  div {
    position: relative;
    cursor: pointer;
    display: block;
    padding-left: 24px;
    &:before {
      content: '';
      position: absolute;
      display: block;
      opacity: 0;
      top: 50%;
      left: 0;
      width: 16px;
      height: 16px;
      margin-top: -8px;
      border-radius: 100%;
      border: 1px solid transparent;
      background-image: linear-gradient(-225deg, #1de9b6 0%, #1dc4e9 100%);
      transition: all 0.15s ease-in-out;
    }
    &:after {
      content: '';
      position: absolute;
      display: block;
      opacity: 1;
      top: 50%;
      left: 0;
      width: 16px;
      height: 16px;
      margin-top: -8px;
      border: 1px solid #e1e1e1;
      border-radius: 100%;
      background-color: #fff;
      transition: all 0.15s ease-in-out;
    }
  }
`;

export const StyledLabel = styled.label`
  ${space};
  position: relative;
  display: block;
`;

export const Label = styled.div`
  ${space};
  font-size: 10px;
  color: #000000;
  margin-left: 8px;
  &:not(:last-child) {
    margin-bottom: 16px;
  }
`;

export const LabelIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  cursor: pointer;
  opacity: 0.5;
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1px solid #ff9e0f;
  color: #ff9e0f;
  font-size: 10px;
  line-height: 1;
  text-align: center;
  transition: opacity 0.15s ease-in-out;
  &:before {
    content: '';
    position: absolute;
  }
  &:not(:first-child) {
    margin-left: 8px;
  }
  &:hover {
    opacity: 1;
  }
`;

export const Copied = styled.div`
  font-size: 0.875rem;
  color: green;
  &:not(:first-child) {
    margin-top: 4px;
  }
`;

export const FieldGroup = styled.div`
  display: flex;
  border: 1px solid #ddd;
  border-radius: 2px;
`;
export const FieldLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-radius: 2px;
  white-space: nowrap;
  font-size: 16px;
  color: #a3a3a3;
`;

export const FieldStyled = styled(Field)`
  width: 100%;
  height: 36px;
  padding: 0.625rem;
  border: 0;
  border-radius: 0;
  color: #464d69;
  text-align: right;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &:not(:last-child) {
    border-right: 1px solid #ddd;
  }
`;

export const SelectStyled = styled(Field)`
  width: 100%;
  height: 28px;
  padding: 0.625rem;
  border: 0;
  border-radius: 20px;
  text-align: right;
  background-color: #fff;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  &:not(:last-child) {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }
  &:not(:first-child) {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

export const StyledButton = styled(Button)`
  &[type='button'] {
    ${space};
  }
  &[type='submit'] {
    ${space};
  }
  background: linear-gradient(
    90deg,
    rgba(41, 10, 89, 0.65) 0%,
    rgba(255, 124, 0, 0.65) 100%
  );
  color: #ffffff !important;
  font-size: 12px !important;
  text-decoration: none !important;
  text-transform: none !important;
  min-width: 190px !important;
  border-radius: 100px !important;
  border: 0;
  padding: 6px 16px !important;
  height: 42px;
  &:hover {
    text-shadow: none;
    box-shadow: none;
  }
  & > span {
    white-space: nowrap;
  }
  &[disabled] {
    background: #e0e0e0 !important;
    color: #707070 !important;
    pointer-events: none !important;
  }
  &[data-nowrap] {
    white-space: nowrap;
  }
`;

export const SingleValue = styled.div`
  color: #fff;
  border-radius: 5px 0 0 5px;
  background-color: #e19635;
  height: 32px;
  padding: 8px 0;
  font-size: 12px;
  text-align: center;
`;

export const StyledButtonLink = styled(Link)`
  ${space};
  background: linear-gradient(
    90deg,
    rgba(41, 10, 89, 0.65) 0%,
    rgba(255, 124, 0, 0.65) 100%
  ) !important;
  color: #ffffff !important;
  font-size: 12px !important;
  text-decoration: none !important;
  text-transform: none !important;
  min-width: 190px !important;
  border-radius: 100px !important;
  border: 0;
  padding: 6px 16px !important;
  height: 42px;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  &:hover {
    text-shadow: none;
    box-shadow: none;
  }
  & > span {
    white-space: nowrap;
  }
  &[disabled] {
    background: #e0e0e0 !important;
    color: #707070 !important;
  }
`;

export const StyledButtonSmall = styled(StyledButton)`
  height: 34px;
`;

export const StyledButtonSmallSquare = styled(Link)`
  ${space};
  background: linear-gradient(
    90deg,
    rgba(41, 10, 89, 0.65) 0%,
    rgba(255, 124, 0, 0.65) 100%
  ) !important;
  color: #ffffff !important;
  font-size: 12px !important;
  text-decoration: none !important;
  text-transform: none !important;
  border: 0;
  padding: 6px 16px !important;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  &:hover {
    text-shadow: none;
    box-shadow: none;
  }
  & > span {
    white-space: nowrap;
  }
  &[disabled] {
    background: #e0e0e0 !important;
    color: #707070 !important;
  }
  height: 32px;
  border-radius: 5px !important;
  min-width: auto !important;
  &[completed='true'] {
    background: #72bcb1 !important;
  }
  &[fullWidth] {
    min-width: 100% !important;
  }
`;

export const LegendWrap = styled.div`
  font-size: 12px;
  padding: 20px 30px 20px 75px;
  background-image: url(${InfoIcon});
  background-repeat: no-repeat;
  background-position: 30px 30px;
  background-color: #f2f3f7;
  border-radius: 5px;
  margin-top: 35px;
  & > p {
    margin: 0;
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledButtonIcon = styled(Button)`
  padding: 0px !important;
  min-width: 36px !important;
  border-radius: 100% !important;
  font-size: 20px;
  ${({ del }) =>
    del &&
    css`
      color: red !important;
    `};
  ${({ save }) =>
    save &&
    css`
      color: green !important;
    `};
  &:disabled {
    opacity: 0.5;
  }
  &:hover {
    border: 0;
    box-shadow: none;
    background: none !important;
  }
`;

export const StyledLink = styled(Button)`
  position: relative;
  min-height: 0 !important;
  height: auto !important;
  padding: 0 !important;
  text-transform: none !important;
  color: ${colors.brand['500']} !important;
  &:before {
    content: '';
    position: absolute;
    opacity: 0.65;
    left: 0;
    right: 0;
    bottom: 0;
    border-bottom: 1px dashed ${colors.brand['500']};
  }
`;

export const CheckLabel = styled.label`
  ${space}
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
`;
